import * as yup from 'yup';

export const validationSchema = yup.object({
  issueDate: yup.string().required(),
});
